import React, { useState } from "react";
import { EMPLOYEE_API_03, USERS_API_07 } from "../../api/ApiModel"; // Add API for verifying old password
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  TextField,
  IconButton,
  InputAdornment,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AddToolbar from "../../components/common/AddToolbar";
import PasswordIcon from "@mui/icons-material/Password";
import { useLocation } from "react-router-dom";

const ChangeUserPassword = ({}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();
  const { userRefCode } = location.state || {};

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERREFCODE, USERNAME, STOREDATE, SETUPDATE } =
    SYS_USER.USER_PARAM || {};
  const goToPage = () => {
    navigate("/");
  };

  const [newPassword, setNewPassword] = useState("");
  const [reason, setReason] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");

  // Toggle password visibility
  const handleTogglePasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const generateStrongPassword = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
    let password = "";
    for (let i = 0; i < 12; i++) {
      password += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    setNewPassword(password);
    setPasswordStrength("Strong");
  };
  // Check password strength and enforce validation rules
  const checkPasswordStrength = (password) => {
    if (password.length === 0) return "";
    if (password.length < 3) return "Weak";

    const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/;
    if (strongRegex.test(password)) return "Strong";

    return "Medium";
  };

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    setPasswordStrength(checkPasswordStrength(value));
  };

  const validateForm = () => {
    if (newPassword.length < 3) {
      setErrorMessage("Password must be at least 8 characters.");
      return false;
    }
    if (passwordStrength === "Weak") {
      setErrorMessage("Password is too weak.");
      return false;
    }
    if (reason.trim().length === 0) {
      setErrorMessage("Reason is required.");
      return false;
    }
    return true;
  };

  // API call to update the password
  const updatePassword = async () => {
    try {
      const today = new Date(); // Get current date
      const formattedToday = today.toISOString().split("T")[0];
      const payload = {
        COMPCODE,
        USERREFCODE: String(USERREFCODE),
        USERNAME: USERNAME,
        reason,
        password: String(newPassword),
        expdate: formattedToday, //SETUPDATE, // Set to appropriate expiration date
        locdate: formattedToday, //STOREDATE,
        enuser: USERNAME,
      };

      const response = await externalpostApi(USERS_API_07, payload);
      console.log("API Response (updatePassword):", response);

      if (response) {
        setSuccessMessage("Password Updated Successfully!");
        setErrorMessage("");
        setNewPassword("");
        setReason("");
      } else {
        setErrorMessage("Password update failed.");
      }
    } catch (error) {
      console.error("Error updating password:", error);
      setErrorMessage("Password update failed.");
    }
  };

  // Handle password change process
  const handlePasswordChange = async () => {
    setErrorMessage("");
    setSuccessMessage("");

    if (!validateForm()) return;

    await updatePassword();
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Users</Link>
                <Link underline="none">Change User Password</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                {/* <Button
                  onClick={goToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button> */}
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: "Change User Password",
          }}
        />
        <Grid container spacing={2} mt={1}>
          <Grid item xs={6}>
            {" "}
            {/* <Box sx={styles.cp_changepwd}> */}
            <Box
              sx={{
                ...styles.cp_changepwd_container,
                height: "100%",
                overflow: "auto",
              }}
            >
              {/* <Box mb={2} textAlign={"center"}>
                <Typography variant="title">Change User Password</Typography>
              </Box> */}

              <Box
                display={"flex"}
                alignItems={"center"}
                gap={1}
                justifyContent={"space-between"}
              >
                <TextField
                  label="New Password"
                  size="small"
                  fullWidth
                  variant="outlined"
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={handleNewPasswordChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleTogglePasswordVisibility}
                          edge="end"
                        >
                          {showNewPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  size="large"
                  variant="contained"
                  onClick={generateStrongPassword}
                  endIcon={<PasswordIcon />}
                  style={{ ...styles.btn_primary, width: "20%" }}
                >
                  Generate
                </Button>
              </Box>
              <Typography
                variant="body2"
                color={
                  passwordStrength === "Strong"
                    ? "green"
                    : passwordStrength === "Weak"
                    ? "red"
                    : "orange"
                }
                mt={1}
              >
                {passwordStrength && `Password Strength: ${passwordStrength}`}
              </Typography>

              <Box pt={2}>
                <TextField
                  label="Reason"
                  size="small"
                  fullWidth
                  variant="outlined"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />

                {errorMessage && (
                  <Typography variant="body2" color="error" mt={2}>
                    {errorMessage}
                  </Typography>
                )}
                {successMessage && (
                  <Typography variant="body2" color="success" mt={2}>
                    {successMessage}
                  </Typography>
                )}
              </Box>

              <Box display={"flex"} pt={2} gap={2}>
                <Button
                  variant="outlined"
                  size="medium"
                  sx={styles.btn_secondary}
                  onClick={() => {
                    setNewPassword("");
                    setReason("");
                    setErrorMessage("");
                  }}
                >
                  Clear
                </Button>
                <Button
                  variant="contained"
                  sx={styles.btn_primary}
                  onClick={handlePasswordChange}
                  size="medium"
                >
                  Confirm
                </Button>
              </Box>
            </Box>
            {/* </Box> */}
          </Grid>
          <Grid item xs={6}>
            {" "}
            <Box sx={styles.cp_changepwd_container}>
              <Typography
                variant="title"
                sx={{ fontWeight: "bold", mb: 2, textAlign: "left" }}
              >
                How to Make a Good Strong Password
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Box
                sx={{
                  height: "50vh",
                  overflow: "auto",
                }}
              >
                {/* Guidelines */}
                <Typography variant="body1" sx={{ mb: 1 }}>
                  A strong password has:
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleOutlineIcon color="success" />
                    </ListItemIcon>
                    <Typography variant="body2">
                      At least 15 characters.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleOutlineIcon color="success" />
                    </ListItemIcon>
                    <Typography variant="body2">Uppercase letters.</Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleOutlineIcon color="success" />
                    </ListItemIcon>

                    <Typography variant="body2">Lowercase letters.</Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleOutlineIcon color="success" />
                    </ListItemIcon>
                    <Typography variant="body2">Numbers.</Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleOutlineIcon color="success" />
                    </ListItemIcon>
                    <Typography variant="body2">
                      Symbols, such as ` ! " ? $ % ^ & * ( ) _ - + = {[]} ; : @
                      ' ~ # | \ &lt; , &gt; . ? /
                    </Typography>
                  </ListItem>
                </List>
                <Divider sx={{ my: 2 }} />

                {/* What a strong password is not */}
                <Typography variant="body1" sx={{ mb: 1 }}>
                  A strong password is:
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <CancelOutlinedIcon color="error" />
                    </ListItemIcon>
                    <Typography variant="body2">Not your username.</Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CancelOutlinedIcon color="error" />
                    </ListItemIcon>
                    <Typography variant="body2">
                      Not your name, your friend’s name, your family member’s
                      name, or a common name.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CancelOutlinedIcon color="error" />
                    </ListItemIcon>
                    <Typography variant="body2">
                      Not your date of birth.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CancelOutlinedIcon color="error" />
                    </ListItemIcon>
                    <Typography variant="body2">
                      Not a dictionary word.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CancelOutlinedIcon color="error" />
                    </ListItemIcon>
                    <Typography variant="body2">
                      Not like your previous passwords.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CancelOutlinedIcon color="error" />
                    </ListItemIcon>
                    <Typography variant="body2">
                      Not a keyboard pattern, such as qwerty, asdfghjkl, or
                      12345678.
                    </Typography>
                  </ListItem>
                </List>

                {/* Footer */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mt: 3,
                    backgroundColor: "#e3f2fd",
                    padding: "10px",
                    borderRadius: "8px",
                  }}
                >
                  <InfoOutlinedIcon color="info" sx={{ mr: 1 }} />
                  <Typography variant="body2" sx={{ color: "#1565c0" }}>
                    Remember to always keep your password secure and do not
                    share it with anyone.
                  </Typography>
                </Box>
              </Box>
            </Box>
            {/* </Box> */}
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default ChangeUserPassword;
